import { createAsyncThunk } from "@reduxjs/toolkit";
import {
	getFeedbackApi,
	changeLangApi,
	loginSuccesApi,
	loginUserApi,
	logoutApi,
	lovedChatsApi,
	postFeedbackApi,
	postImageApi,
	postMessageApi,
	postPredictionApi,
	signUpApi,
	toggleChatLoveApi,
	loadChatsApi,
	submitFormApi,
} from "./api";

export const signUp = createAsyncThunk("signUp", async (payload) => {
	try {
		const res = await signUpApi(payload);
		return res.data;
	} catch (err) {
		console.log(err);
		throw err.response.data;
	}
});

export const loginUser = createAsyncThunk("loginUser", async (payload) => {
	const res = await loginUserApi(payload);
	return res.data;
});

export const loginSuccess = createAsyncThunk("loginSuccess", async () => {
	const res = await loginSuccesApi();
	return res.data;
});

export const logout = createAsyncThunk("logout", async () => {
	const res = await logoutApi();
	return res;
});

export const postMessage = createAsyncThunk("postMessage", async (payload) => {
	const res = await postMessageApi(payload);
	return res.data;
});

export const loadChatsAction = createAsyncThunk("loadChats", async (payload) => {
	const res = await loadChatsApi(payload);
	return res.data;
});

export const postFeedback = createAsyncThunk("postFeedback", async (payload) => {
	try {
		const response = await postFeedbackApi(payload);
		return response;
	} catch (error) {
		return error;
	}
});
export const postPrediction = createAsyncThunk("postPrediction", async (payload) => {
	console.log("response auth", payload);
	try {
		const response = await postPredictionApi(payload);
		console.log("response", response);
		return response;
	} catch (error) {
		console.log("errrrrrrrrr", error);
		return error;
	}
});

export const getFeedback = createAsyncThunk("getFeedback", async (payload) => {
	const res = await getFeedbackApi(payload);
	return res.data;
});

export const langChangeSuccess = createAsyncThunk("langChangeSuccess", async (payload) => {
	const res = await changeLangApi(payload);
	return res.data;
});

export const postImage = createAsyncThunk("postImage", async (payload) => {
	try {
		const res = await postImageApi(payload);
		return res.data;
	} catch (err) {
		console.log(err);

		throw err;
	}
});

export const toggleChatLove = createAsyncThunk("toggleChatLove", async (payload) => {
	const res = await toggleChatLoveApi(payload);
	return res.data;
});

export const lovedChats = createAsyncThunk("lovedChats", async () => {
	const res = await lovedChatsApi();
	return res.data;
});

export const submitForm = createAsyncThunk("submitForm", async (payload) => {
	const res = await submitFormApi(payload);
	return res.data;
});
